export const LABELS_CREATED_SUCCESS = 'LABELS_CREATED_SUCCESS'
export const LABELS_CREATED_WITH_ERRORS = 'LABELS_CREATED_WITH_ERRORS'
